import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { CircularProgress, withStyles } from '@material-ui/core'
import { getCustomAttributes } from 'actions/contacts'
import { styles, Section } from './Sections'
// import { startCase } from 'lodash'

const DraggableFields = ({
	customAttributesLoadStatus,
	customAttributes,
	getCustomAttributes,
	classes,
}) => {
	if (!customAttributesLoadStatus) {
		getCustomAttributes()
	}

	const defaultSections = [
		{ label: 'Email' },
		{ label: 'Phone' },
		{ label: 'First name' },
		{ label: 'Middle name' },
		{ label: 'Last name' },
		{ label: 'Location' },
	]

	const customSections = customAttributesLoadStatus
		? Object.values(customAttributes)
				.filter((customAttribute) => customAttribute.name)
				.map((customAttribute) => ({
					label: customAttribute.name,
				}))
		: []

	const sections = [...defaultSections, ...customSections]

	return (
		<div>
			<div style={{ marginBottom: 10, color: '#014c94' }}>
				Drag and drop the contact fields below to the desired preview area of
				your form.
				{/* Add contact fields below to your form. */}
			</div>
			<div style={{ maxHeight: 300, overflowY: 'auto', overflowX: 'hidden' }}>
				{sections.map((section) => {
					return (
						<Section
							draggable
							key={`customFormSection${section.label}`}
							type="sectionPill"
							classes={classes}
							disabled={false}
							label={section.label}
							addSection={() => console.log(section)}
						/>
					)
				})}
			</div>
			{customAttributesLoadStatus ? null : <CircularProgress />}
		</div>
	)
}

export default connect(
	(state) => ({
		customAttributesLoadStatus: state.loadStatus.customAttributes,
		customAttributes: state.contacts.customAttributes,
	}),
	(dispatch) => bindActionCreators({ getCustomAttributes }, dispatch),
)(withStyles(styles)(DraggableFields))
